import styled from "styled-components";
import IconButton from "@mui/material/IconButton";
import colors from "../../../constants/colors";

export const AuthModalBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(92vw, 420px);
  max-height: calc(100vh - 32px);
  overflow: auto;
  background-color: ${colors.WHITE};
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(21, 29, 72, 0.18);
  padding: 1.5rem 1.5rem 2rem;
  outline: none;
  direction: rtl;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const AuthModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
`;

export const AuthModalTitle = styled.h2`
  margin: 0;
  color: ${colors.BLACK};
  font-size: 1.15rem;
  font-weight: 600;
`;

export const AuthModalSubtitle = styled.p`
  margin: -0.5rem 0 0;
  color: ${colors.GREY_7};
  font-size: 0.9rem;
`;

export const AuthCloseButton = styled(IconButton)`
  && {
    color: ${colors.GREY_7};
    padding: 0.25rem;
  }
`;
